// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2957":"2e5a60a0a85d12fc228a","5338":"7eb7c1e6d2a45f69344e"}[chunkId] + ".js";
};